import CheckboxGroup from './group/CheckboxGroup'
import { CheckboxGroupInput } from './group/CheckboxGroupInput'

const Checkbox = {
  Group: CheckboxGroup,
  GroupInput: CheckboxGroupInput,
}

export default Checkbox
